import Image from 'next/legacy/image';

import { BodyRegular } from '@common/body';
import { H2Small, H3, H5 } from '@common/headline';
import { TakeOurQuizButton } from '../Hero/TakeOurQuizCTA';
import { TrustpilotBox } from './TrustpilotBox';

import WomanWithCardsDesktop from '@public/img/how-it-works/woman-with-cards-desktop.png';
import WomanWithCardsMobile from '@public/img/how-it-works/woman-with-cards-mobile.png';

const title = (
  <>
    There{"'"}s no point taking Mounjaro unless you also
    <span className="text-mono-white"> change your habits.</span>
  </>
);

const subtitle = (
  <span>
    Lose up to 20-25% of your body weight with Mounjaro medication and our
    habit-change programme, learn lifelong healthy habits to keep the weight
    off, and improve your mood, sleep, and energy.
  </span>
);

type Props = {
  utmCampaign?: string;
  utmMedium?: string;
  utmSource?: string;
};

export const MounjaroMedicallySupportedPlanHero = ({
  utmCampaign,
  utmMedium,
  utmSource,
}: Props): JSX.Element => (
  <div className="relative flex h-[700px] bg-salmon pt-8 text-center text-blue lg:min-h-[606px] lg:px-[60px] lg:pb-12 lg:pt-[152px]">
    <div className="hidden h-full flex-1 lg:flex" />
    <div className="container m-auto flex h-[100%] w-[100%] justify-center pt-[56px] lg:max-w-[640px] xxl:max-w-[720px]">
      <div className="hidden justify-center text-left lg:flex lg:flex-col">
        <div className="mb-4">
          <H2Small>{title}</H2Small>
        </div>
        <div className="mb-8 max-w-[579px]">
          <H5>{subtitle}</H5>
        </div>
        <div className="mb-8">
          <TakeOurQuizButton
            colour="NavyBlue"
            ctaText="Check my eligibility"
            isGlp1
            location="Medically supported programme hero"
            type="Primary"
            utmCampaign={utmCampaign}
            utmMedium={utmMedium}
            utmSource={utmSource}
          />
        </div>
        <TrustpilotBox medication="Mounjaro" />
      </div>
      <div className="flex flex-col justify-center lg:hidden">
        <div className="flex flex-col px-3">
          <div className="max-w-[500px] pb-2">
            <H3>{title}</H3>
          </div>
          <div className="max-w-[500px]">
            <BodyRegular>{subtitle}</BodyRegular>
          </div>
        </div>
        <div className="relative h-full w-full">
          <div className="absolute bottom-2 z-10 flex w-full flex-col px-3">
            <TakeOurQuizButton
              colour="NavyBlue"
              ctaText="Check my eligibility"
              fullWidth
              isGlp1
              location="Medically supported programme hero"
              type="Primary"
              utmCampaign={utmCampaign}
              utmMedium={utmMedium}
              utmSource={utmSource}
            />
            <div className="pb-2">
              <TrustpilotBox medication="Mounjaro" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="flex justify-end lg:w-[50%]">
      <div className="absolute bottom-0 right-0 hidden h-full max-h-[550px] w-[50%] lg:block">
        <Image
          alt="Woman on programme"
          layout="fill"
          objectFit="contain"
          objectPosition="right bottom"
          src={WomanWithCardsDesktop}
        />
      </div>
      <div className="absolute bottom-0 h-full max-h-[380px] w-full lg:hidden">
        <Image
          layout="fill"
          objectFit="contain"
          objectPosition="bottom"
          src={WomanWithCardsMobile}
        />
      </div>
    </div>
  </div>
);
